module.exports = __webpack_public_path__ + "img/function_01.e3aedf68.png";